module.exports = __webpack_public_path__ + "img/inbox.53fad49a.svg";